import { useEffect, useState } from 'react';
import { motion, useMotionValue, useSpring } from 'framer-motion';

export default function Cursor() {
  const [enabled, setEnabled] = useState(false);
  const [label, setLabel] = useState('');
  const [active, setActive] = useState(false);
  const x = useMotionValue(-100);
  const y = useMotionValue(-100);
  const sx = useSpring(x, { stiffness: 500, damping: 40, mass: 0.4 });
  const sy = useSpring(y, { stiffness: 500, damping: 40, mass: 0.4 });

  useEffect(() => {
    const fine = window.matchMedia('(pointer: fine)').matches;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!fine || reduced) return;
    setEnabled(true);
    document.documentElement.classList.add('cursor-active');

    const move = (e) => {
      x.set(e.clientX);
      y.set(e.clientY);
    };
    const over = (e) => {
      const tagged = e.target.closest('[data-cursor]');
      if (tagged) {
        setLabel(tagged.getAttribute('data-cursor'));
        setActive(true);
        return;
      }
      const interactive = e.target.closest('a, button, input, textarea, [role="button"]');
      setLabel('');
      setActive(!!interactive);
    };
    window.addEventListener('mousemove', move, { passive: true });
    document.addEventListener('mouseover', over, { passive: true });
    return () => {
      window.removeEventListener('mousemove', move);
      document.removeEventListener('mouseover', over);
      document.documentElement.classList.remove('cursor-active');
    };
  }, [x, y]);

  if (!enabled) return null;

  return (
    <motion.div
      data-testid="custom-cursor"
      className="pointer-events-none fixed left-0 top-0 z-[200] flex items-center justify-center rounded-full"
      style={{
        x: sx,
        y: sy,
        translateX: '-50%',
        translateY: '-50%',
        backgroundColor: label ? '#47a0d9' : 'rgba(255,255,255,0.9)',
        mixBlendMode: label ? 'normal' : 'difference',
      }}
      animate={{
        width: label ? 84 : active ? 40 : 12,
        height: label ? 84 : active ? 40 : 12,
      }}
      transition={{ type: 'spring', stiffness: 400, damping: 28 }}
    >
      {label && (
        <span className="font-display text-[10px] font-semibold uppercase tracking-[0.2em] text-black">
          {label}
        </span>
      )}
    </motion.div>
  );
}
